<template>
        <div class="Frame">
        <div class="ShoppingInfoIndex">
            <h2>{{ this.risorse["DatiFatturazione"] }}</h2>
            <span>{{ this.risorse["IndirizzoFatturazione"] }}</span>
        </div>
        <div class="ShoppingInfo">
            <!-- Inizio repeater -->
            <div class="ShoppingInfoDetail SelectedItem">
                <div class="SummaryText">
                    <span>{{ this.$store.getters.getAzienda.Anagrafica.Indirizzo}}</span> <span>{{ this.$store.getters.getAzienda.Anagrafica.Cap}} {{ this.$store.getters.getAzienda.Anagrafica.Citta}},</span> <span>({{ this.$store.getters.getAzienda.Anagrafica.Provincia}})</span>
                </div>
            </div>
            <!-- Fine repeater -->
        </div>
    </div>
</template>
<script>
import {risorseMixin} from "@/mixin.js";

export default {
    name: "BillingAddress",
    mixins:[risorseMixin]
    
}
</script>